import { useMutation } from '@tanstack/react-query';
import updatePlatformNumber from 'API/PlatformNumber/updatePlatformNumber';
import { toast } from 'react-toastify';
import Platforms from 'utils/platforms';

// (2993) Reverted — commented out rather than deleted, see commit cfe2c9c58.
// import { useQueryClient } from '@tanstack/react-query';

const useUpdateAllPlatformNumbers = (
    data,
    accountScope,
    refetchPlatformNumbers,
    refreshTable,
    previousData,
    onClose,
) => {
    // (2993) const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            try {
                let allSuccessful = true;
                for (const [index, item] of data.entries()) {
                    if (previousData[index] !== item) {
                        if (
                            JSON.stringify(previousData[index]) !==
                            JSON.stringify(item)
                        ) {
                            try {
                                await updatePlatformNumber({
                                    formData: item,
                                    scope: accountScope,
                                });
                                // (2993) queryClient.invalidateQueries({
                                //     queryKey: ['numberID', item.numberID],
                                // });
                            } catch (error) {
                                const errorMessage = `Failed to update platform number for ${
                                    Platforms[item?.platformID].name
                                }: ${error?.response?.data?.message}`;
                                console.error(errorMessage);
                                toast.error(errorMessage);
                                allSuccessful = false;
                            }
                        }
                    }
                }
                if (
                    allSuccessful &&
                    JSON.stringify(previousData) !== JSON.stringify(data)
                ) {
                    refreshTable();
                    refetchPlatformNumbers();
                    onClose();
                    toast.success('Platform Numbers Updated');
                }
            } catch (error) {
                const errorMessage = `Failed to update platform numbers: ${error?.response?.data?.message || 'Please try again later.'}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
    });
};

export default useUpdateAllPlatformNumbers;
